var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoMin = function SvgLogoMin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logoMin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.835 27.548h11.743V32H.963V11.13h5.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA5B0C",
    d: "M39.715 5.565h-9.394v16.418h4.697v-5.287h4.697c2.921 0 5.285-2.24 5.285-5.009v-1.113c0-2.769-2.364-5.009-5.285-5.009m.587 5.788c0 1.044-.895 1.906-2.01 1.906h-3.274V8.807h3.273c1.101 0 2.011.849 2.011 1.906zM23.275 5.565v10.296c0 1.224-1.057 2.226-2.348 2.226h-1.175c-1.291 0-2.348-1.002-2.348-2.226V0H.964l11.743 7.944v7.917c0 3.38 2.891 6.122 6.458 6.122h2.202c3.64 0 6.606-2.81 6.606-6.261V5.565z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logoMin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v32H0z"
  })))));
};
export default SvgLogoMin;